<script setup lang="ts">
import {useFavorites} from "~/composables/useFavorites";
import {useAuth} from "~/composables/useAuth";

const props = defineProps({
  eventId: {type: String, required: true}
})

const {on} = useEventBus();
const {openModal} = useModal();
const signinModal = () => openModal('sign-modal')
const {saveFavorite, findAllFavorite, isFavorite} = useFavorites()
const {isAuthenticated, user} = useAuth()

  onMounted(async () => {
  if (isAuthenticated.value) await findAllFavorite()
})

const _class = computed(() => isFavorite(props.eventId) ? 'bg-primary text-white' : '')

const _saveFavorite = async () => {
  if (isAuthenticated.value) {
    await saveFavorite(props.eventId)
  } else {
    signinModal()
    on('login-success', async () => {
      await findAllFavorite()
      await saveFavorite(props.eventId)
    });
  }
}
</script>
<template>
  <span>
    <client-only>
      <button
          :class="`btn btn-icon btn-light-primary btn-xs shadow-sm rounded-circle ms-2 mb-2 ${_class}`"
          type="button"
          data-bs-toggle="tooltip" title="Adicionar a lista de desejos"
          @click="_saveFavorite"
      >
        <i class="fi-heart cursor-pointer"></i>
      </button>
    </client-only>
  </span>
</template>
